import { QueryParam, QueryParamKey } from 'types/common/queryParam.type';
import { Location } from 'react-router-dom';
/**
 *
 * @param searchString location.search
 * @param key 추출할 QueryParam Type
 * @returns {QueryParam[K]}
 * TODO: searchString window.location.search 로 변경
 */
export const extractParams = <K extends QueryParamKey>(searchString: string, key: K): QueryParam[K] | undefined => {
  const queryParams: URLSearchParams = new URLSearchParams(searchString);
  const value = queryParams.get(key);
  if (value) {
    return value as QueryParam[K];
  }

  return '';
};

/**
 * @desc client path 추출
 * @param searchString location.pathname
 * @returns
 */
export const extractPath = (searchString: string): string => {
  try {
    const match = searchString.match(/web\/([^/]+)/); // 정규식으로 추출
    if (match && match[1]) {
      return match[1];
    }
    return '';
  } catch (error) {
    console.error('URL 처리 중 오류 발생:', error);
  }
  return '';
};

/**
 * @desc url에 따라서 domain type 체크
 * @param location
 * @returns domain type
 */
export const extractUrlDomainType = (location: Location): string => {
  // 현재 URL의 경로와 쿼리 문자열을 가져옵니다.
  const pathname = location?.pathname; // 예: "/web"
  const searchParams = extractParams(location?.search, 'pointId'); // 예: "?type=mobile"
  const searchTypeParam = extractParams(location?.search, 'type'); // 예: "?type=mobile"

  // 경로와 쿼리 값 확인
  const isWebPath = pathname.includes('web'); // 경로가 'web'인지 확인
  const isMobileSearch = searchParams && searchParams?.length > 0;

  const isExceptSearch = searchTypeParam && searchTypeParam?.length > 0;

  if (isWebPath && isExceptSearch) {
    return 'WEB';
    // 처리 로직
  }

  if (isWebPath) {
    return 'WEB';
    // 처리 로직
  }
  if (isMobileSearch) {
    return 'MOBILE';
    // 처리 로직
  }
  console.log('조건에 맞는 값이 없습니다.');
  return 'ERROR';
};
